export default __webpack_public_path__ + "static/media/soso-white-small.98567674.png";